const { Component } = require('react');
const React = require('react');
const ReduxProvider = require('utils/framework/ReduxProvider');


const wrapWithProvider = WrappedComponent => {
    class WithProvider extends Component {
        render() {
            const {
                children, ...props
            } = this.props;

            return (
                <ReduxProvider>
                    <WrappedComponent {...props}>
                        {children}
                    </WrappedComponent>
                </ReduxProvider>
            );
        }
    }
    WithProvider.displayName = `WithProvider(${WrappedComponent.displayName})`;

    return WithProvider;
};

module.exports = wrapWithProvider;
